const state = {
  sidebar: {
    opened: false,
  },
  loader: false,
  config: {
    palette: {
      primary: '#000000',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd',
    },
  },
  isLoading: false,
}

const mutations = {
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  SET_GLOBAL_LOADER (state, loader) {
    state.loader = loader
  },
}

const actions = {
}

export default {
  state,
  mutations,
  actions,
}
